import axios from 'axios';

import cfac22 from '../cfac22';

export default function getUserInboxMessages(uId, origin, startAt, endAt, limit) {
  return new Promise((resolve, reject) => {
    if (uId) {
      Promise.resolve().
      then(() => {
        axios.
        post(
          `${cfac22('API_HOST_V2')}/notification/inbox`,
          {
            origin: origin,
            startAt: startAt,
            endAt: endAt,
            limit: limit
          },
          {
            headers: {

              'Content-Type': 'application/json',
              'Full-Url': window.location.href
            }, withCredentials: true
          }
        ).
        then((result) => {
          resolve(result.data.result);
        }).
        catch((error) => {
          reject(error);
        });
      }).
      catch((error) => {
        reject(error);
      });
    } else {
      reject(null);
    }
  });
}
